import {
  getBooleanSchema,
  getStringSchema,
  getSelectSchema,
  getPercentSchema,
  getNullableIntegerSchema,
} from 'src/compass/shared/schemas';
import * as Yup from 'yup';

export const CMESourceSchema = Yup.object().shape({
  description: getStringSchema(50, 'Description'),
  isActive: getBooleanSchema('Active', true),
  sourceType: getSelectSchema('Type'),
  lrpglAccountInfo: getStringSchema(50, "LRP G/L Account").notRequired(),
  asOf: Yup.object().shape({
    cmeRatePercent: getPercentSchema('CME Rate'),
    lrpRatePercent: getPercentSchema('LRP Rate'),
    adjust: getBooleanSchema('Adjust', false),
    adjustAfterYears: Yup.mixed().when('adjust', {
      is: true,
      then() {
        return getNullableIntegerSchema('After Years')
          .required(`"Required`)
          .moreThan(0, 'After Years must be greater than 0');
      },
      otherwise(schema) {
        return schema.notRequired().transform((value, originalValue) => {
          if (typeof originalValue === 'string' && originalValue.trim() === '') return null;
          return value;
        });
      },
    }),
    adjustAfterYearsByPercent: Yup.mixed().when('adjust', {
      is: true,
      then() {
        return getPercentSchema('Adjust by');
      },
      otherwise(schema) {
        return schema.notRequired().transform((value, originalValue) => {
          if (typeof originalValue === 'string' && originalValue.trim() === '') return null;
          return value;
        });
      },
    }),
  }),
});
